/* eslint-disable no-unused-vars */
/** @module Auth0PostLoginHandlerDevDataDump */
/* eslint-disable import/extensions */
import Auth0UtilsBrowser from '../../../../utils/auth0-utils-browser.mjs';
import Auth0PostLoginHandlerBase from '../auth0-post-login-handler-base.mst.mjs';

const ENABLE = false;

class Auth0PostLoginHandlerDevDataDump extends Auth0PostLoginHandlerBase {
  constructor(options) {
    super(options);

    if (ENABLE) {
      console.log('Auth0PostLoginHandlerDevDataDump data dump');
      console.log('Typed derived from Auth0PostLoginHandlerBase have access to the following (constructor)...');
      console.log(JSON.stringify(options, null, 2));
    }
  }

  /**
   * @inheritdoc
   */
  async shouldHandle(loginData) {
    const r = await Promise.resolve(ENABLE);
    // DEV: return true to override the normal selection of the post login handler and use this one. Auth will break, but the console will show the data you need.
    return r;
  }

  /**
   * @inheritdoc
   */
  async run(loginData) {
    // dump loginData (lots of stuff here... if you need it, it's likely already in there)
    console.log('Auth0PostLoginHandlerDevDataDump data dump');
    console.log('Typed derived from Auth0PostLoginHandlerBase have access to the following (shouldHandle and run)...');
    console.log(JSON.stringify(loginData, null, 2));
    // dump browser state
    Auth0UtilsBrowser.dumpVars();
  }
}

export default Auth0PostLoginHandlerDevDataDump;
